export const ADMIN_ROLES = ["ADMIN", "SUPER_ADMIN"];

export const isAdminUser = (user) => Boolean(user && ADMIN_ROLES.includes(String(user.role || "").toUpperCase()));

export const adminRouteAccess = (user) => {
  if (user === null) return "LOADING";
  return isAdminUser(user) ? "ALLOW" : "REDIRECT";
};

export const reviewCaseActionsForTarget = (targetType) => {
  switch (String(targetType || "").toUpperCase()) {
    case "REVIEW":
      return ["NO_ACTION", "HIDE_REVIEW", "REMOVE_REVIEW"];
    case "MEDIA":
      return ["NO_ACTION", "HIDE_MEDIA", "REMOVE_MEDIA"];
    default:
      return ["NO_ACTION"];
  }
};

export const resolutionPayloadForQueueItem = (item, action, note, editedChanges = null) => {
  if (!item?.source_type || !item?.source_id) throw new Error("Review queue item is required");
  const resolutionNote = String(note || "").trim();
  if (!resolutionNote) throw new Error("Resolution note is required");

  if (item.source_type === "SUGGEST_EDIT") {
    if (!["APPROVE", "REJECT"].includes(action)) throw new Error("Suggest Edit requires APPROVE or REJECT");
    return {
      source_type: item.source_type,
      source_id: item.source_id,
      decision: action,
      resolution_note: resolutionNote,
      ...(action === "APPROVE" && editedChanges ? { edited_changes: editedChanges } : {}),
    };
  }
  if (item.source_type === "ADD_DESTINATION") {
    if (!["APPROVE", "REJECT"].includes(action)) throw new Error("Add Destination requires APPROVE or REJECT");
    return { source_type: item.source_type, source_id: item.source_id, decision: action, resolution_note: resolutionNote };
  }
  if (item.source_type === "ADD_TRAIL") {
    if (!["APPROVE", "REJECT"].includes(action)) throw new Error("Add Trail requires APPROVE or REJECT");
    return { source_type: item.source_type, source_id: item.source_id, decision: action, resolution_note: resolutionNote };
  }
  if (item.source_type === "REPORT") {
    const allowed = reviewCaseActionsForTarget(item.target_type);
    if (!allowed.includes(action)) throw new Error(`Unsupported moderation action '${action}' for ${item.target_type || "target"}`);
    return { source_type: item.source_type, source_id: item.source_id, action, resolution_note: resolutionNote };
  }
  if (item.source_type === "STATUS_CHANGE") {
    if (!["APPROVE", "REJECT"].includes(action)) throw new Error("Status Change requires APPROVE or REJECT");
    return { source_type: item.source_type, source_id: item.source_id, decision: action, resolution_note: resolutionNote };
  }
  throw new Error(`Unsupported review queue source '${item.source_type}'`);
};

export const parseAdminChanges = (value) => String(value || "")
  .split("\n")
  .map((line) => line.trim())
  .filter(Boolean)
  .map((line) => {
    const separator = line.indexOf("=");
    if (separator <= 0) throw new Error(`Invalid change '${line}'. Use field=value.`);
    const field = line.slice(0, separator).trim();
    const fieldValue = line.slice(separator + 1).trim();
    if (!field || !fieldValue) throw new Error(`Invalid change '${line}'. Use field=value.`);
    return { field, value: fieldValue };
  });

export const moveFeaturedId = (ids, destinationId, direction) => {
  const next = [...ids];
  const index = next.indexOf(destinationId);
  const target = direction === "up" ? index - 1 : index + 1;
  if (index < 0 || target < 0 || target >= next.length) return next;
  [next[index], next[target]] = [next[target], next[index]];
  return next;
};

export const safeJson = (value) => {
  if (!value) return null;
  try { return JSON.parse(value); } catch { return value; }
};
